import React, { FunctionComponent } from 'react';
import { EventModel } from 'features/events/EventModel';
import { FullScreenDetails } from 'components/Layouts/FullScreenView/FullScreenDetails';
import { FullScreenFooter } from 'components/Layouts/FullScreenView/FullScreenFooter';
import { EventMeta } from 'features/events/components/EventMeta';
import { ListenerCount } from 'components/ListenerCount';
import { useIsEventLive } from 'features/events/eventHooks';
import { HeartButton } from 'components/Hearts/HeartButton';
import { Share } from 'components/Share';
import { FullScreenControls } from 'components/Layouts/FullScreenView/FullScreenControls';
import { useMediaQuery } from 'react-responsive';
import { VolumeControl } from 'components/Player/VolumeControl';
import { useAppSelector } from 'hooks/redux';

interface EventFooterProps {
  event: EventModel | null;
}

export const EventEmbedFooter: FunctionComponent<EventFooterProps> = ({
  event
}) => {
  const isLive = useIsEventLive(event);
  const showHeartButton = useMediaQuery({ query: '(min-width: 400px)' });

  const removeBranding = useAppSelector(
    (state) => state.channel?.channelDetails?.removeEmbedBranding || false
  );

  if (!event) {
    return null;
  }

  if (isLive) {
    return (
      <FullScreenFooter
        leftColumn={
          <>
            <VolumeControl />
            <FullScreenDetails
              title={event.title}
              meta={
                <>
                  <EventMeta />
                  <ListenerCount />
                </>
              }
            />
          </>
        }
        rightColumn={
          <FullScreenControls>
            {showHeartButton && !removeBranding && <HeartButton />}
            {!removeBranding && <Share title={event.title} label={'event'} />}
          </FullScreenControls>
        }
      />
    );
  }

  return null;
};
